
<div class="slideshow">
  <swiper-container initialSlide="0" slidesPerView="1" pagination="false" effect="cube" cubeEffect="{slideShadows: false}" autoplay="true" delay="300">
    <swiper-slide *ngFor="let slide of slides">
      <div class="h2">{{slide.header}}</div>
      <div class="image"><img [src]="showImage(slide)" class="slide-image"/></div>
      <div class="content">
        <p [innerHtml]="slide.content"></p>
      </div> 
    </swiper-slide>
  </swiper-container>  
</div>